import React from 'react'
import { supplyPerMan } from '../supply'
import { C } from '../theme'

// Presentational "type a count for each unit" table, shared by the inline RosterGrid (editing an
// existing army) and the Recruit modal (composing a fresh batch). Purely controlled: the caller
// owns the `counts` map (code -> value) and the row list; this just renders and reports edits.
const cell = { padding: '3px 6px', fontSize: 13 }
const numIn = { width: 58, padding: '3px 5px', borderRadius: 4, border: `1px solid ${C.rule}`, background: C.paperRaised, color: C.ink, textAlign: 'right', fontSize: 13 }

// Live men/wage/supply totals for a set of rows + counts.
export function rosterTotals(rows, counts) {
  let men = 0, wage = 0, supply = 0
  for (const t of rows) {
    const n = Number(counts[t.code]) || 0
    men += n; wage += n * (t.wage_per_man || 0); supply += n * supplyPerMan(t)
  }
  return { men, wage, supply }
}

export default function RosterTable({ rows, counts, onChange, canEdit = true, maxHeight = 260 }) {
  if (!rows.length) return <div style={{ opacity: 0.5, fontSize: 12 }}>Troop catalog unavailable.</div>
  return (
    <div style={{ maxHeight, overflowY: 'auto', border: `1px solid ${C.rule}`, borderRadius: 6 }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          {rows.map((t, i) => {
            const n = Number(counts[t.code]) || 0
            return (
              <tr key={t.code} style={{ background: n ? C.highlight : (i % 2 ? C.paperSunken : C.paperRaised) }}>
                <td style={{ ...cell, opacity: n ? 1 : 0.72 }}>
                  {t.name}
                  <span style={{ opacity: 0.5, marginLeft: 5, fontSize: 11 }}>{Number(t.wage_per_man || 0).toFixed(2)}gp</span>
                </td>
                <td style={{ ...cell, textAlign: 'right', width: 70 }}>
                  {canEdit ? (
                    <input style={numIn} type="number" min={0} value={counts[t.code] ?? ''} placeholder="0"
                      onChange={e => onChange(t.code, e.target.value === '' ? '' : Math.max(0, Number(e.target.value)))} />
                  ) : n}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
